var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-container" }, [
    _c(
      "div",
      { staticClass: "header_nav  w", class: !_vm.isLogin ? "unLogin" : "" },
      [
        _c(
          "div",
          {
            staticClass: "nav_logo",
            on: {
              click: function($event) {
                return _vm.$router.push("/")
              }
            }
          },
          [
            _c("img", {
              staticClass: "pointer",
              staticStyle: { width: "104px" },
              attrs: { src: _vm.config.logo, alt: _vm.config.site_title }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "nav_right" }, [
          _c("div", { staticClass: "nav_group" }, [
            _c(
              "div",
              { staticClass: "nav-group-left" },
              [
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: { "active-class": "nav-active", to: "/#home" }
                      },
                      [_vm._v("后台首页\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/resource/news?is_zimeiti=2"
                        }
                      },
                      [
                        _vm._v("\n            门户媒体\n            "),
                        _c("svg-icon", {
                          staticStyle: {
                            width: "30px",
                            height: "16px",
                            position: "relative",
                            top: "-5px"
                          },
                          attrs: { "icon-class": "hot" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/resource/zimeiti?is_zimeiti=1"
                        }
                      },
                      [_vm._v("自媒体\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/own/publish"
                        }
                      },
                      [_vm._v("文章发布\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.is_new !== 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/own/copy_write"
                        }
                      },
                      [_vm._v("文章代写\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.recharge === 1
                  ? _c(
                      "a",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          href: _vm.config.indexHost + "/product/monitoring",
                          target: "_blank"
                        }
                      },
                      [_vm._v("舆情监测\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.profile.recharge === 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav_btn",
                        attrs: {
                          "active-class": "nav-active",
                          to: "/recharge_center"
                        }
                      },
                      [_vm._v("在线充值\n          ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "head_top_right" },
          [
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "bottom-end",
                  width: "274",
                  trigger: "hover"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "user",
                    attrs: { slot: "reference" },
                    slot: "reference"
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "30px" },
                      attrs: { src: _vm.profile.avatar, alt: "" }
                    }),
                    _vm._v(
                      "\n           ID: " +
                        _vm._s(_vm.profile.id) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "user-popover" }, [
                  _c("div", { staticClass: "user-info-box" }, [
                    _c("img", { attrs: { src: _vm.profile.avatar, alt: "" } }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "fz-16 fw-b" }, [
                        _vm._v("会员名：" + _vm._s(_vm.profile.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fz-14" }, [
                        _vm._v("用户ID:" + _vm._s(_vm.profile.id))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "balance-box mt-10 fz-14 fw-b" },
                    [
                      _c("svg-icon", {
                        staticStyle: {
                          width: "22px",
                          height: "22px",
                          color: "#0070ef",
                          "margin-left": "16px",
                          "margin-right": "9px"
                        },
                        attrs: { "icon-class": "currency" }
                      }),
                      _vm._v("\n            账户余额： "),
                      _c("span", { staticStyle: { color: "#ff2222" } }, [
                        _vm._v(_vm._s(_vm.profile.balance))
                      ]),
                      _vm._v(" 元\n          ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-popover-links" }, [
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "12px",
                            height: "16px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover01.svg"
                          }
                        }),
                        _vm._v("\n              用户中心\n              "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/own/copy_write" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "11px",
                            height: "14px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover02.svg"
                          }
                        }),
                        _vm._v("\n              文章撰写\n              "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/recharge_center" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "11px",
                            height: "13px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover03.svg"
                          }
                        }),
                        _vm._v("\n              在线充值\n              "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-popover-link-item",
                        attrs: { href: "/own/personal/profile" }
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "14px",
                            height: "12px",
                            "margin-right": "8px"
                          },
                          attrs: {
                            "icon-class":
                              "https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                          }
                        }),
                        _vm._v("\n              个人资料\n              "),
                        _c("div", { staticClass: "flex-spacer" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logout" }, [
                    _c(
                      "a",
                      { staticClass: "pointer", on: { click: _vm.onLogout } },
                      [_vm._v("退出登录")]
                    )
                  ])
                ])
              ]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc92a38e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc92a38e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Header.vue
// module id = null
// module chunks = 